import React, { useState, useEffect } from 'react';
import { Link as ScrollLink } from 'react-scroll';
import { FaBars, FaTimes } from 'react-icons/fa';


const titleStyle = {
  fontFamily: "'Script MJ Bold', sans-serif",
  fontWeight: 'bold'
};

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isVisible, setIsVisible] = useState(true);
  const [lastScrollY, setLastScrollY] = useState(0);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > lastScrollY) {
        setIsVisible(false);
      } else {
        setIsVisible(true);
      }
      setLastScrollY(window.scrollY);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [lastScrollY]);

  return (
    <header className={isVisible ? 'header visible' : 'header hidden'}>
      <div className="logo">
        <ScrollLink to="hero" smooth={true} duration={500}>
          <span style={titleStyle}>TIMELESS</span>
        </ScrollLink>
      </div>

      <div className="hamburger" onClick={toggleMenu}>
        {isOpen ? <FaTimes /> : <FaBars />}
      </div>

      <nav className={isOpen ? 'nav-links open' : 'nav-links'}>
        <ScrollLink to="hero" smooth={true} duration={500} onClick={toggleMenu}>
          Home
        </ScrollLink>
        <ScrollLink to="properties" smooth={true} duration={500} onClick={toggleMenu}>
          Properties
        </ScrollLink>
        <ScrollLink to="about" smooth={true} duration={500} onClick={toggleMenu}>
          About Us
        </ScrollLink>
        <ScrollLink to="contact" smooth={true} duration={500} onClick={toggleMenu}>
          Contact Us
        </ScrollLink>
      </nav>
    </header>
  );
};

export default Header;
